export var IVipSuperStatus;
(function (IVipSuperStatus) {
    // 未开通过超会
    IVipSuperStatus[IVipSuperStatus["NOT_YET"] = 1] = "NOT_YET";
    // 超会正常使用
    IVipSuperStatus[IVipSuperStatus["USING"] = 2] = "USING";
    // 超会已过期
    IVipSuperStatus[IVipSuperStatus["EXPIRED"] = 3] = "EXPIRED";
})(IVipSuperStatus || (IVipSuperStatus = {}));
export var EVipStatus;
(function (EVipStatus) {
    EVipStatus[EVipStatus["NO_STATUS"] = 0] = "NO_STATUS";
    EVipStatus[EVipStatus["CLOSE"] = 1] = "CLOSE";
    EVipStatus[EVipStatus["OPEN"] = 2] = "OPEN";
    EVipStatus[EVipStatus["EXPIRED"] = 3] = "EXPIRED";
})(EVipStatus || (EVipStatus = {}));
export var ExpiredStatus;
(function (ExpiredStatus) {
    ExpiredStatus[ExpiredStatus["EXPIRED"] = 1] = "EXPIRED";
    ExpiredStatus[ExpiredStatus["SUPER_VIP_EXPIRED"] = 2] = "SUPER_VIP_EXPIRED";
})(ExpiredStatus || (ExpiredStatus = {}));
export var VipType;
(function (VipType) {
    VipType["NORMAL"] = "NORMAL";
    VipType["SUPER"] = "SUPER";
    VipType["SUPER_PLUS"] = "SUPER_PLUS";
    VipType["NONE"] = "NONE";
    VipType["EXPIRED"] = "EXPIRED";
})(VipType || (VipType = {}));
export var VipLevel;
(function (VipLevel) {
    VipLevel[VipLevel["NORMAL"] = 2] = "NORMAL";
    VipLevel[VipLevel["SUPER"] = 3] = "SUPER";
    VipLevel[VipLevel["SUPER_PLUS"] = 4] = "SUPER_PLUS";
    VipLevel[VipLevel["NONE"] = 1] = "NONE";
    VipLevel[VipLevel["EXPIRED"] = 0] = "EXPIRED";
})(VipLevel || (VipLevel = {}));
export var CorpVipLevel;
(function (CorpVipLevel) {
    CorpVipLevel[CorpVipLevel["INVALID_CORP_VIP_LEVEL"] = 0] = "INVALID_CORP_VIP_LEVEL";
    CorpVipLevel[CorpVipLevel["CORP_VIP_LEVEL_BASIC"] = 1] = "CORP_VIP_LEVEL_BASIC";
    CorpVipLevel[CorpVipLevel["CORP_VIP_LEVEL_PRO"] = 2] = "CORP_VIP_LEVEL_PRO";
})(CorpVipLevel || (CorpVipLevel = {}));
export var EUserVipType;
(function (EUserVipType) {
    EUserVipType[EUserVipType["NONE"] = 1] = "NONE";
    EUserVipType[EUserVipType["NORMAL"] = 2] = "NORMAL";
    EUserVipType[EUserVipType["SUPER"] = 3] = "SUPER";
    EUserVipType[EUserVipType["SUPER_PLUS"] = 4] = "SUPER_PLUS";
})(EUserVipType || (EUserVipType = {}));
export var EUserRenewalStatus;
(function (EUserRenewalStatus) {
    EUserRenewalStatus[EUserRenewalStatus["NONE"] = 0] = "NONE";
    EUserRenewalStatus[EUserRenewalStatus["AUTO_RENEWAL"] = 1] = "AUTO_RENEWAL";
    EUserRenewalStatus[EUserRenewalStatus["CLOSED"] = 2] = "CLOSED";
})(EUserRenewalStatus || (EUserRenewalStatus = {}));
